// Relationships — contacts, talent, brands, vendors. People the studio works with.

import { PageHeader, StubBanner } from '../components/Page';
import { Card, CardLabel, CardTitle } from '../components/Card';
import { T } from '../theme';

export default function Relationships() {
  return (
    <>
      <PageHeader
        title="Relationships"
        subtitle="Every person the studio touches — contacts, talent, brands, vendors, partners."
      />

      <StubBanner section="relationships" />

      <div style={relStyles.grid}>
        <Card>
          <CardLabel>i · Contacts</CardLabel>
          <CardTitle>The full address book</CardTitle>
          <p style={relStyles.muted}>
            Every person across every channel. Same human, different surfaces (WhatsApp,
            Slack, email), one record. Powered by the shared Contacts API.
          </p>
        </Card>

        <Card>
          <CardLabel>ii · Talent</CardLabel>
          <CardTitle>Artists + creators</CardTitle>
          <p style={relStyles.muted}>
            Roster view. Career stage, audience size, recent releases, performance
            history. Cross-references campaigns and bookings.
          </p>
        </Card>

        <Card>
          <CardLabel>iii · Brands</CardLabel>
          <CardTitle>Client organizations</CardTitle>
          <p style={relStyles.muted}>
            Labels, agencies, brands with active or past campaigns. Primary contacts,
            historical spend, current pipeline.
          </p>
        </Card>

        <Card>
          <CardLabel>iv · Vendors</CardLabel>
          <CardTitle>Distribution + service partners</CardTitle>
          <p style={relStyles.muted}>
            Clip farms, paid social agencies, DSP partners, sync agencies. Performance
            history per campaign, contract terms, contact info.
          </p>
        </Card>

        <Card>
          <CardLabel>v · Partners</CardLabel>
          <CardTitle>Studio + regional partners</CardTitle>
          <p style={relStyles.muted}>
            Allied operators running on Dreamlink Studio. Cross-deployment relationships,
            referral history, shared deal flow.
          </p>
        </Card>

        <Card>
          <CardLabel>vi · Audit log</CardLabel>
          <CardTitle>Who did what, when</CardTitle>
          <p style={relStyles.muted}>
            Every relationship change tracked. Who created the contact, who updated
            the role, who owns the relationship today.
          </p>
        </Card>
      </div>
    </>
  );
}

const relStyles: Record<string, React.CSSProperties> = {
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: 20,
  },
  muted: {
    fontSize: 14,
    color: T.inkSoft,
    lineHeight: 1.65,
  },
};
